import { Expression } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class ExpressionOfflineDataUpdateCacher extends OfflineDataUpdateCacher<Expression> {
    constructor() {
        super(dbCacheUp.expression)
    }
}